import React from "react";
// import {Router, hashHistory} from "react-router";
import {
  HashRouter
} from "react-router-dom";

import MainIndexComponent from "./bvcomponents";
// import qkbRoutes from "./qkbRoutes";
import {fixVisualizerType} from "./misc/visualizerSwitchingFunctions";
import {hardCodeIsAmericanStandard, hardCodeIsAmericanImport, hardCodeIsCaesarStone, hardCodeIsModerno, hardCodeIsLowes} from "./misc/fabricatorHardcode";


if(window.Sfdc && window.Sfdc.canvas && typeof(sr) != 'undefined') {
  console.log("Sfdc available and sr is defined");
  try {
    // Subscribe to a custom event.
    window.Sfdc.canvas(function() {
      window.Sfdc.canvas.client.subscribe(sr.client,
          {name : "quoteCountertops.canvasLoadEvent",
          onData: () => {
            console.log('QC Visualizer received quoteCountertops.canvasLoadEvent');
            window.salesForceLoaded = true;
            window.Sfdc.canvas.client.publish(sr.client, {
              name: "quoteCountertops.canvasOn",
              payload: true
            });
        }});

        window.Sfdc.canvas.client.publish(sr.client, {
          name: "quoteCountertops.canvasReady",
          payload: true
        });

        console.log('sending fake canvasLoadEvent');
        window.Sfdc.canvas.client.publish(sr.client, {
          name: "quoteCountertops.canvasLoadEvent",
          payload: true
        });
    });
  } catch(ex) {
    console.log('SalesForce capable, but not running in salesforce', ex);
  }
}

window.addEventListener("message", (event) => {
  // console.log(event);
  if (event.data && event.data.name === "quoteCountertops.canvasLoadEvent") {
    console.log('Message received', event);
    window.sfdcMessage = event.source;
    window.salesForceLoaded = true;
  }
});

//window.postMessage({name: "quoteCountertops.canvasLoadEvent"});

export default class App extends React.Component {

  constructor(props) {
    super(props);
    // switch (document.kvConfig.userId) {
    //   case 139864:
    //   case 142022:
    //     document.kvConfig.visualizerType = "kvMaster";
    //     break;
    //   case 140028:
    //   case 140029:
    //     document.kvConfig.visualizerType = "kvScene";
    //     document.kvConfig.layersSize = "full_hd";
    //     break;
    //   case 140031:
    //   case 152152:
    //   case 140036: // https://bathroom_8k_2.quotesflooring.com/visualizer#/
    //   case 154840: // https://american_import_brv5.quotekitchenandbath.com/visualizer#/
    //     document.kvConfig.visualizerType = "bvScene";
    //     document.kvConfig.layersSize = "full_hd";
    //     break;
    //   default:
    //     break;
    // }

    fixVisualizerType();

    if (hardCodeIsCaesarStone()) {
      document.body.classList.remove('theme-qc');
      document.body.classList.add('theme-caes');
    } else if (hardCodeIsAmericanImport()) {
      document.body.classList.remove('theme-qc');
      document.body.classList.add('theme-as-5');
    } else if (hardCodeIsAmericanStandard()) {
      document.body.classList.remove('theme-qc');
      document.body.classList.add('theme-as');
    } else if (hardCodeIsModerno()) {
      document.body.classList.remove('theme-qc');
      document.body.classList.add('theme-moderno');
    } else if (hardCodeIsLowes()) {
      document.body.classList.add('bv--lowes');
    }
    console.log('document.kvConfig.visualizerType:', document.kvConfig.visualizerType);
    console.log('document.kvConfig.navigationType:', document.kvConfig.navigationType);
    if (!document.kvConfig.isBackend) {
      document.kvConfig.isBackend = window.location.href.includes("mode=dashboard");
    }
    document.bvConfig = {
      "showPlaceholders": document.kvConfig.visualizerType === "BV" || document.kvConfig.visualizerType === "Bathroom",
    };
  }

  render() {

    // if (IS_QKB_UI) {
    //   return (
    //     <Router history={hashHistory}>
    //       {qkbRoutes}
    //     </Router>
    //   );
    // }

    return (
      <HashRouter>
        <MainIndexComponent/>
      </HashRouter>
    );
  }
}
